__webpack_require__.hmrF = () => ("blocks." + __webpack_require__.h() + ".hot-update.json");